<template>
  <path
    d="M5.93996 18.9902H15C15.65 18.9902 16.26 18.6802 16.63 18.1502L20.58 12.5802C20.83 12.2302 20.83 11.7702 20.58 11.4202L16.62 5.84018C16.26 5.31018 15.65 5.00018 15 5.00018H5.93996C5.12996 5.00018 4.65996 5.93018 5.12996 6.59018L8.99996 12.0002L5.12996 17.4102C4.65996 18.0702 5.12996 18.9902 5.93996 18.9902Z"
  />
</template>
